import cx from 'classnames';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import styles from './styles.module.less';

const AutoresizeTextarea = props => {
  const newProps = { ...props };
  const isSmallInput = props.size === 'small';

  newProps.className = cx(styles.textArea, props.className, {
    [styles.sizeSmall]: isSmallInput,
    [styles.sizeMedium]: !isSmallInput,
  });
  newProps.ref = props.textRef;
  delete newProps.textRef;

  return <TextareaAutosize {...newProps}></TextareaAutosize>;
};

export default AutoresizeTextarea;
